import Joi from "joi"
import { SelectInput, SelectInputProps } from "react-admin"

export const DisabledSelectInput: React.FC<SelectInputProps> = (props) => (
  <SelectInput source={props.source} fullWidth={props.fullWidth} disabled choices={[]} />
)
